import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import dialogue from './module/dialogue'
import taskDialogue from './module/taskDialogue'
import survey from './module/survey'
import countermeasureCardDialogue from './module/countermeasureCardDialogue'
import caseStudy from './module/caseStudy'
import {getToken, removeToken, removeUserInfo} from "@/utils/auth";
import router from "@/router";

Vue.use(Vuex)

const sessionDefaults = JSON.parse(JSON.stringify({
  user: user.state, dialogue: dialogue.state, taskDialogue: taskDialogue.state,
  survey: survey.state, caseStudy: caseStudy.state,
  countermeasureCardDialogue: countermeasureCardDialogue.state,
}));

export default new Vuex.Store({
  state: {
    sessionGeneration: 0,
    itemTypeList: {
      scale: 'ChatAnswerSheet',
      guide_language: 'ChatText',
      user_input: 'ChatSend',
      problem_goal_motive: 'ChatAnswerSheet',
      current_mood_score: 'ChatAnswerSheet',
      mood_recognize_named: 'ChatAnswerSheet',
      auto_mindset_recognize: 'ChatAnswerSheet',
      twelve_mind_distort: 'ChatAnswerSheet',
      cognize_reestablish: 'ChatAnswerSheet',
      happly_exercise_list: 'ChatAnswerSheet',
      behaviour_exercise_plan: 'ChatAnswerSheet',
      primary_troubles_qst: 'ChatProblem',
      trouble_category_qst: 'ChatCheckbox',
      set_goal_qst: 'ChatProblem',
      do_you_agree: 'ChatConfirm',
      my_actions_qst: 'ChatActions',
      mood_ruler_qst: 'ChatEmotionalRuler',
      mood_respond: 'ChatText',
      mood_diary_qst: 'ChatTextarea',
      recall_qst: 'ChatReconstructionCard',
      twelve_problems_qst: 'ChatTwelveProblemsAst',
      categories_qst: 'ChatCheckboxActivity',
      mood_categories_qst: 'ChatEmotion',
      mood_categories: 'ChatEmotionReadOnly',
      mood_describe_qst: 'ChatEmotionDetails',
      recognize_methods_qst: 'ChatAutomatedMindSelect',
      thoughts_describe_qst: 'ChatAutomatedMind',
      strategy_card_qst: 'ChatStrategyCard',
      goal_progress: 'ChatAnswerSheet',
      goal_progress_qst: 'ChatProgressCard',
      strategy_practice: 'ChatAnswerSheet',
      video: 'ChatAnswerSheet',
      case_study: 'ChatAnswerSheet',
      schedule: 'ChatAnswerSheet',
      therapy_calendar: 'ChatAnswerSheet',
      relax_exercise: 'ChatAnswerSheet'
    },
  },
  getters: {
  },
  mutations: {
    clearSession(state) {
      Object.entries(sessionDefaults).forEach(([moduleName, initial]) => {
        Object.keys(initial).forEach(key => {
          state[moduleName][key] = JSON.parse(JSON.stringify(initial[key]));
        });
      });
      state.sessionGeneration += 1;
    },
  },
  actions: {
    userLoginOut({ state, commit }) {
      const hadSession = Boolean(getToken() || state.user.userInfo || state.dialogue.id);
      removeToken()
      removeUserInfo();
      if (hadSession) {
        commit('clearSession');
        Object.keys(sessionStorage).filter(key => key.startsWith('icbt-survey-draft-') || key === 'icbt-dialogue-task-entry')
          .forEach(key => sessionStorage.removeItem(key));
      }
      router.replace({ path: '/login'}).catch(() => console.log(''))
    }
  },
  modules: {
    user,
    app,
    survey,
    dialogue,
    taskDialogue,
    countermeasureCardDialogue,
    caseStudy
  }
})
